import { useAppSelector } from '_hooks';
import { SkatingPassFlow } from '_organisms';
import React from 'react';

const Passes: React.FC = () => {
  // Get authentication state from Redux store
  const { isAuthenticated } = useAppSelector((state: any) => state.auth);

  return (
    <div className="max-w-7xl mx-auto">
      <div className={`text-center ${isAuthenticated ? 'mb-8' : 'mb-0'}`}>
        <h1 className="text-lg md:text-3xl font-bold text-gray-900 mb-2">
          10-Pack and Season Passes
        </h1>
        {isAuthenticated && (
          <p className="text-gray-600">
            Select your preferred pass and complete your booking
          </p>
        )}
      </div>
      <SkatingPassFlow />
    </div>
  );
};

export default Passes;
